import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ContactDialog from "@/components/ContactDialog";
import { ContactDialogProvider } from "@/context/ContactDialogContext";
import Home from "@/pages/Home";
import Features from "@/pages/Features";
import Pricing from "@/pages/Pricing";
import Villkor from "@/pages/Villkor";
import Integritet from "@/pages/Integritet";
import Cookies from "@/pages/Cookies";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const NotFound = () => (
  <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6" data-testid="page-not-found">
    <h1 className="font-serif text-5xl text-white">Sidan finns inte</h1>
    <p className="mt-4 text-white/65">Sidan du letar efter kunde inte hittas.</p>
    <a href="/" className="mt-8 btn-gold inline-flex px-7 py-3 rounded-full" data-testid="notfound-home-link">
      Till startsidan
    </a>
  </div>
);

function App() {
  return (
    <div className="App min-h-screen bg-[#0a1128] text-[#FAF7F0]">
      <BrowserRouter>
        <ContactDialogProvider>
          <ScrollToTop />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/funktioner" element={<Features />} />
              <Route path="/priser" element={<Pricing />} />
              <Route path="/villkor" element={<Villkor />} />
              <Route path="/integritet" element={<Integritet />} />
              <Route path="/cookies" element={<Cookies />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <ContactDialog />
        </ContactDialogProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
